/**
 * FAQ Tabs Section - Simplified for debugging
 * Handles tab switching and FAQ expand/collapse functionality
 */

(function() {
  'use strict';
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    const sections = document.querySelectorAll('.prolon-faq-tabs-container');
    
    if (sections.length === 0) {
      return;
    }
    
    sections.forEach(initFAQSection);
  }
  
  function initFAQSection(container) {
    // Get elements
    const tabButtons = container.querySelectorAll('.prolon-tab-btn');
    const tabContents = container.querySelectorAll('.prolon-tab-content');
    const faqTriggers = container.querySelectorAll('.prolon-faq-trigger');
    
    // Initialize indicator line position for the first active tab
    const indicator = container.querySelector('.prolon-tab-indicator');
    if (indicator && tabButtons.length > 0) {
      const totalTabs = tabButtons.length;
      const firstTabWidth = (1 / totalTabs) * 100; // First tab is 1/totalTabs * 100
      indicator.style.width = firstTabWidth + '%';
      indicator.style.transform = 'translateX(0%)'; // Start at left
    }
    
    // Initialize tab switching
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const tabId = button.dataset.tabId;
        switchTab(tabId, index, container);
      });
    });
    
    // Initialize FAQ accordions
    faqTriggers.forEach((trigger) => {
      const faqId = trigger.dataset.faqId;
      const faqTitle = trigger.querySelector('.prolon-faq-title');
      
      // Add hover event listeners for title styling
      trigger.addEventListener('mouseenter', () => {
        const faqItem = trigger.closest('.prolon-faq-item');
        // Only change to bold on hover if not already expanded
        if (faqTitle && !faqItem.classList.contains('expanded')) {
          faqTitle.classList.remove('text-body-regular');
          faqTitle.classList.add('text-body-bold');
        }
      });
      
      trigger.addEventListener('mouseleave', () => {
        const faqItem = trigger.closest('.prolon-faq-item');
        // Only change back to regular if not expanded
        if (faqTitle && !faqItem.classList.contains('expanded')) {
          faqTitle.classList.remove('text-body-bold');
          faqTitle.classList.add('text-body-regular');
        }
      });
      
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        
        const faqItem = trigger.closest('.prolon-faq-item');
        const faqContent = faqItem.querySelector('.prolon-faq-content');
        
        if (!faqItem || !faqContent) {
          console.warn('FAQ item or content not found', faqId);
          return;
        }
        
        const isExpanded = faqItem.classList.contains('expanded');
        
        if (isExpanded) {
          collapseFAQ(faqItem, faqContent);
        } else {
          // Close other FAQs in the same tab first
          const currentTab = faqItem.closest('.prolon-tab-content');
          if (currentTab) {
            const otherFAQs = currentTab.querySelectorAll('.prolon-faq-item.expanded');
            otherFAQs.forEach(otherFAQ => {
              const otherContent = otherFAQ.querySelector('.prolon-faq-content');
              if (otherContent) {
                collapseFAQ(otherFAQ, otherContent);
              }
            });
          }
          
          expandFAQ(faqItem, faqContent);
        }
      });
    });
  }
  
  function switchTab(tabId, index, container) {
    // Update active tab button
    const tabButtons = container.querySelectorAll('.prolon-tab-btn');
    const tabContents = container.querySelectorAll('.prolon-tab-content');
    
    tabButtons.forEach(btn => {
      btn.classList.remove('active');
      btn.classList.remove('text-cta-text');
      btn.classList.add('text-cta-non-selected');
      // Update ARIA attributes for accessibility
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('tabindex', '-1');
    });
    const activeButton = container.querySelector(`[data-tab-id="${tabId}"]`);
    if (activeButton) {
      activeButton.classList.add('active');
      activeButton.classList.remove('text-cta-non-selected');
      activeButton.classList.add('text-cta-text');
      // Update ARIA attributes for active tab
      activeButton.setAttribute('aria-selected', 'true');
      activeButton.setAttribute('tabindex', '0');
    }
    
    // Update indicator line position
    const indicator = container.querySelector('.prolon-tab-indicator');
    if (indicator) {
      const totalTabs = tabButtons.length;
      const cumulativeWidth = ((index + 1) / totalTabs) * 100; // Cumulative width from start to current tab
      
      indicator.style.width = cumulativeWidth + '%';
      indicator.style.transform = 'translateX(0%)'; // Always start from left
    }
    
    // Update active tab content
    tabContents.forEach(content => {
      content.classList.remove('active');
      content.style.display = 'none';
      content.setAttribute('hidden', '');
    });
    
    const activeContent = container.querySelector(`[data-tab-content="${tabId}"]`);
    if (activeContent) {
      // First set display to block to enable transitions
      activeContent.style.display = 'block';
      activeContent.removeAttribute('hidden');
      
      // Force a reflow to ensure the display change takes effect before adding the active class
      activeContent.offsetHeight;
      
      // Now add the active class for the transition to kick in
      activeContent.classList.add('active');
    }
    
    // Close all open FAQs when switching tabs
    const allFAQItems = container.querySelectorAll('.prolon-faq-item.expanded');
    allFAQItems.forEach(faqItem => {
      const faqContent = faqItem.querySelector('.prolon-faq-content');
      if (faqContent) {
        collapseFAQ(faqItem, faqContent);
      }
    });
  }
  
  function expandFAQ(faqItem, faqContent) {
    faqItem.classList.add('expanded');
    
    // Calculate content height
    const contentHeight = faqContent.scrollHeight;
    faqContent.style.maxHeight = contentHeight + 'px';

    // Update ARIA attributes for accessibility
    const trigger = faqItem.querySelector('.prolon-faq-trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
    
    // Update FAQ title classes - add bold, remove regular
    const faqTitle = faqItem.querySelector('.prolon-faq-title');
    if (faqTitle) {
      faqTitle.classList.remove('text-body-regular');
      faqTitle.classList.add('text-body-bold');
    }
    
    // Rotate the plus icon to make an X (45 degrees)
    const iconWrapper = faqItem.querySelector('.prolon-faq-icon');
    if (iconWrapper) {
      iconWrapper.style.transform = 'rotate(45deg)';
    }
  }
  
  function collapseFAQ(faqItem, faqContent) {
    // Set specific height before collapsing for smooth transition
    faqContent.style.maxHeight = '0px';
    
    // Update the class
    faqItem.classList.remove('expanded');

    // Update ARIA attributes for accessibility
    const trigger = faqItem.querySelector('.prolon-faq-trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
    
    // Update FAQ title classes - remove bold, add regular
    const faqTitle = faqItem.querySelector('.prolon-faq-title');
    if (faqTitle) {
      faqTitle.classList.remove('text-body-bold');
      faqTitle.classList.add('text-body-regular');
    }
    
    // Reset the icon rotation back to plus
    const iconWrapper = faqItem.querySelector('.prolon-faq-icon');
    if (iconWrapper) {
      iconWrapper.style.transform = 'rotate(0deg)';
    }
  }
  
})();
